import React, { useCallback, useEffect, useState } from "react";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";
import moment from "moment";
import { tw } from "@careinfo/tailwind";
import { useSessionStorage } from "@uidotdev/usehooks";
import { hasValues } from "../../utils/hasValues";
import { useForm } from "react-hook-form";
import { AccessControl } from "@careinfo/permission-required";
import Card from "../Reusable/Card";
import OrderFilter from "./OrderFilter";
interface IFilterCombobox {
  id: string;
  name: string;
  [key: string]: any;
}
export interface IFilterDanfe {
  pickup_branch: IFilterCombobox | null;
  destination: IFilterCombobox | null;
  created__range: string | null;
  delivery_partner__slug: IFilterCombobox | null;
}
const OrderList = () => {
  const [localState, handleSetState] = useSessionStorage<IFilterDanfe>(
    "order-filter-danfe",
    {
      pickup_branch: null,
      destination: null,
      created__range: null,
      delivery_partner__slug: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<IFilterDanfe>({
    defaultValues: async () => ({
      pickup_branch: localState?.pickup_branch ?? null,
      destination: localState?.destination ?? null,
      created__range: localState?.created__range ?? null,
      delivery_partner__slug: localState?.delivery_partner__slug ?? null,
    }),
  });
  const handleFilterReset = () => {
    reset({
      pickup_branch: null,
      destination: null,
      delivery_partner__slug: null,
    });
  };

  const defaultColumns = [
    {
      header: "Created",
      accessorKey: "logistic_order.created",
      cell: ({ cell: { getValue } }) => {
        const value = getValue();
        if (!value) return <p>N/A</p>;

        const date = moment(value).format("YY-MM-DD");
        const time = moment(value).format("HH:mm:ss");

        return (
          <div className={tw`flex flex-col`}>
            <span className={tw`whitespace-nowrap`}>{date}</span>
            <span>{time}</span>
          </div>
        );
      },
    },
    {
      header: "Tracking Number",
      accessorKey: "logistic_order.tracking_number",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "logistic_order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "logistic_order.sender.full_name",
      cell: ({ row }: any) => {
        return (
          <>
            <p className={tw``}>
              {row?.original?.logistic_order?.sender?.full_name ?? "N/A"}{" "}
            </p>

            <p className={tw`whitespace-nowrap text-sm`}>
              {row?.original?.logistic_order?.sender?.primary_contact ?? "N/A"}{" "}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row }: any) => {
        return (
          <div className={tw`w-full `}>
            <p className={tw``}>
              {row?.original?.logistic_order?.receiver.full_name ?? "N/A"}{" "}
            </p>

            <p className={tw`whitespace-nowrap text-sm`}>
              {row?.original?.logistic_order?.receiver.primary_contact ?? "N/A"}{" "}
            </p>

            <p className={tw`text-sm w-full max-w-[200px]`}>
              {row?.original?.logistic_order?.receiver.address ?? "N/A"}{" "}
            </p>
          </div>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "logistic_order.destination.name",
      cell: NACell,
    },
    {
      header: "Delivery Partner ",
      accessorKey: "delivery_partner.name",
      cell: ({ row }: any) => {
        const partnerName = row?.original?.delivery_partner?.name;
        const deliveryOrder = row?.original?.delivery_order;

        return (
          <div className={tw`whitespace-nowrap`}>
            <span>{partnerName ?? "N/A"}</span>
            {partnerName === "NCM" && deliveryOrder && (<span className={tw`ml-1 text-gray-500`}>
              ({deliveryOrder})
            </span>
            )}
          </div>
        );
      },
    },
  ];
  const filterParams = watch();
  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          // newValue[key] = value.id;
          if (key === "delivery_partner__slug") {
            newValue[key] = value.slug;
          } else {
            newValue[key] = value.id;
          }
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);

  return (
    <>
      <AccessControl allowedPermissions={["can_edit_filter"]}>
        <Card
          title="Filters"
          onClick={() => setFilterVisiable(!isFilterVisible)}
        >
          <OrderFilter
            isFilterVisible={isFilterVisible}
            register={register}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            reset={handleFilterReset}
            watch={watch}
            clearErrors={clearErrors}
            control={control}
          />
        </Card>
      </AccessControl>
      <DataTable
        url={APIS.ORDER}
        queryKey={"order"}
        columns={defaultColumns}
        params={params()}
        tableName={"Orders"}
      />
    </>
  );
};

export default OrderList;
